<template>
    <ChatAgentToolFrame class="md:w-full max-w-[600px]">
        <div class="flex flex-col gap-4" data-testid="chat-action-items">
            <fieldset class="flex flex-col gap-4">
                <legend class="nadia-chat-bold w-full pb-4 text-center text-ink">{{ t("chat.actionItems.title") }}</legend>
                <ul class="flex flex-col gap-3">
                    <li v-for="(item, idx) in action.action_params?.action_items" :key="`action-item-${idx}`">
                        <BaseCheckbox :model-value="!!item.checked" tone="success" @update:model-value="checkItem(idx)">
                            <span class="body-small" :class="item.checked ? 'text-ink-muted line-through' : 'text-ink'">{{ item.content }}</span>
                        </BaseCheckbox>
                    </li>
                </ul>
            </fieldset>
        </div>
    </ChatAgentToolFrame>
</template>

<script setup>
import BaseCheckbox from "~vue/components/form/BaseCheckbox.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { inject } from "vue";
import { useI18n } from "vue-i18n";

import ChatAgentToolFrame from "./ChatAgentToolFrame.vue";

const { t } = useI18n();

const props = defineProps({
    action: {
        type: Object,
        default: () => ({}),
    },
    lineIdx: { type: Number, required: true },
    messageId: { type: Number, required: true },
});

const { emitter } = inject("globalProperties");
const coachingSessionUuid = inject("coachingSessionUuid");

function checkItem(idx) {
    const item = props.action.action_params.action_items[idx];
    item.checked = !item.checked;

    emitter.emit("action_items", {
        subaction: "check_item",
        item_index: idx,
        checked: item.checked,
        message_id: props.messageId,
        lineIdx: props.lineIdx,
        action_params: props.action.action_params,
        action_state: {
            submitted: false,
        },
    });
    logUserInteraction("action_items_checked", {}, coachingSessionUuid);
}
</script>
